import { useMemo } from 'react';
import { isDisabledConfig } from './selectors';
import useFeature from './useFeature';

export type FeatureLock =
  | { isLocked: false }
  | { isLocked: true; reason?: string };

/**
 * Resolves the lock state for a feature at `path`, normalizing across the
 * two different locked shapes for a given feature - the generic `locked` state
 * for a tile, usually controlled at the organization level ("your administrator
 * has locked this feature") and the `DisabledConfig` derived from the lockspec
 * configuration.
 */
export default function useFeatureLock(
  path: Array<string | number>,
): FeatureLock {
  const state = useFeature(path);

  return useMemo<FeatureLock>(() => {
    if (state === 'locked') {
      return { isLocked: true };
    }

    if (isDisabledConfig(state)) {
      return { isLocked: true, reason: state.reason };
    }

    return { isLocked: false };
  }, [state]);
}
